<template>
<div class="chapter">
<div class="inner_page">
<p class="fmt"><span><a id="page_vi"></a><a id="page_vii"><b>CONTENTS</b></a></span></p><a id="page_vii">
</a><p class="toc2" id="rack"><a id="page_vii"><span></span></a><a href="#/xhtml/acknowledgments#ack">Acknowledgments</a></p>
<p class="toc2" id="rprl"><span><a href="#/xhtml/prologue#prl">Prologue</a></span></p>
<div style="margin-left:1.5em;">
<p class="hang" id="rch01"><span><a href="#/xhtml/chapter01#ch01"><span class="big">1</span>  The Encounter: The Many Paths to CrossFit</a></span></p>
<p class="hang" id="rch02"><span><span href="#/xhtml/chapter02#ch02" title="Link target outside of Sample"><span class="big">2</span>  The Unknown and the Unknowable: What Is CrossFit All About?</span></span></p>
<p class="hang" id="rch03"><span><span href="#/xhtml/chapter03#ch03" title="Link target outside of Sample"><span class="big">3</span>  Inside the Box: The World Within a CrossFit Affiliate</span></span></p>
<p class="hang" id="rch04"><span><span href="#/xhtml/chapter04#ch04" title="Link target outside of Sample"><span class="big">4</span>  Making the Invisible Visible: CrossFit’s Focus on Movement and Mobility</span></span></p>
<p class="hang" id="rch05"><span><span href="#/xhtml/chapter05#ch05" title="Link target outside of Sample"><span class="big">5</span>  Two Oars in the Water: CrossFit’s One-Two Punch of Diet and Exercise</span></span></p>
<p class="hang" id="rch06"><span><span href="#/xhtml/chapter06#ch06" title="Link target outside of Sample"><span class="big">6</span>  CultFit: The Community and Sociology of CrossFit</span></span></p>
<p class="hang" id="rch07"><span><span href="#/xhtml/chapter07#ch07" title="Link target outside of Sample"><span class="big">7</span>  Irene’s Journey: A Case Study</span></span></p>
<p class="hang" id="rch08"><span><span href="#/xhtml/chapter08#ch08" title="Link target outside of Sample"><span class="big">8</span>  The Jet Stream of High Performance: The Making of a Firebreather</span></span></p>
<p class="hang" id="rch09"><span><span href="#/xhtml/chapter09#ch09" title="Link target outside of Sample"><span class="big">9</span>  My Date with Fran</span></span></p>
</div>
<p class="toc1d" id="repi"><span><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue: The Future of CrossFit</span></span></p>
<p class="toc2" id="rglry"><span><span href="#/xhtml/terms#glry" title="Link target outside of Sample">Glossary of Terms</span></span></p>
<p class="toc1" id="rglry1"><span><span href="#/xhtml/exercises#glry1" title="Link target outside of Sample">Glossary of Exercises</span></span></p>
<p class="toc1" id="rabt"><span><span href="#/xhtml/author#abt" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?d9acadac